import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Shared from '../Shared.styles';
import * as S from './ScenarioNoAssets.styles';

export interface ScenarioNoAssetsProps {
  label?: string;
  onClick?: () => void;
}

export const ScenarioNoAssets = ({ label, onClick }: ScenarioNoAssetsProps) => {
  const { t } = useTranslation('scenario');

  return (
    <Shared.Container data-testid="scenario-no-assets">
      <Shared.Img
        src="/terminal/static/images/icons/no-assets-found.svg"
        alt=""
      />
      <S.Description>
        <Shared.Title>{t('scenario:emptyState:noAssetsTitle')}</Shared.Title>
        <Shared.Message>
          {t('scenario:emptyState:noAssetsMessage')}
        </Shared.Message>
      </S.Description>

      <Button variant="primary" size="medium" label={label} onClick={onClick} />
    </Shared.Container>
  );
};
